import React, { useEffect, useState } from "react";
import Logout from "@mui/icons-material/Logout";
import AccountCircleIcon from "@mui/icons-material/AccountCircle";
import toast, { Toaster } from "react-hot-toast";
import { useLocation, useNavigate } from "react-router-dom";
import logo from "../../image/ayekart logo.png";
import AuthService from "../../services/auth.service";
import { removeToken } from "../../redux/tokenSlice";
import Loader from "../Loader";
import axios from "axios";
import { Box, ListItemIcon, Popover } from "@mui/material";
import { useDispatch } from "react-redux";
// import "./FinanceGridView.css";
 

function OperationsAyekartRetailWDGridView() {
  const location = useLocation();
  const history = useNavigate();
  const userDetails = JSON.parse(localStorage.getItem("user_detail"));
  const [businessCategory, setBusinessCategory] = useState([]);
  const [loading, setLoading] = useState(false);
  const [anchorEl, setAnchorEl] = React.useState(null);
  const [gridOrders, setGridOrders] = useState([]);
  const [markAsPaid, setMarkAsPaid] = useState(false);
  const [toGetUpdatedList, setTogetUpdatedList] = useState(false);
  const [status, setStatus] = useState("");
  const [allOrdersTotal, setAllOrdersTotal] = useState(0);
  const [selectAll, setSelectAll] = useState(false);
  const [dummy, setDummy] = useState(false);
  const [statusArray, setStatusArray] = useState([]);
  const [formObj, setFormObj] = useState([]);
  const [selectedOrdersTotal, setSelectedOrdersTotal] = useState(0);
  const [downloadSheetFlag, setDownloadSheetFlag] = useState(false);
  const [currentGridId, setCurrentGridId] = useState(location?.state?.id);
  const [gridPage, setGridPage] = useState(location?.state?.gridPage || 1);
  const [totalGrids] = useState(location?.state?.totalGrids || 0);
  const [activeTab] = useState(location?.state?.activeTab ?? 0);
  const [searchQuery] = useState(location?.state?.searchQuery || "");

  const gridId = currentGridId ?? location?.state?.id;
  const tabNames = ["Pending", "Approved", "Paid", "Rejected"];

  const resetGridViewState = () => {
    setMarkAsPaid(false);
    setSelectAll(false);
    setSelectedOrdersTotal(0);
    setDownloadSheetFlag(false);
  };

  const getTableData = () => {
    if (!gridId) return;
    const token = localStorage.getItem("token");
    setLoading(true);
    setDownloadSheetFlag(false);
    fetch(`/workflow/api/${gridId}/orders`, {
      headers: { Authorization: `Bearer ${token}` },
    })
      .then((res) => res.json())
      .then((res) => {
        if (res?.grid_status === "Paid") {
          setDownloadSheetFlag(true);
        }
        let temp = [];
        let sum = 0;
        res?.orders.map((item, index) => {
          if (item?.grid_status === "Paid") {
            setDownloadSheetFlag(true);
          }
          sum = sum + Number(item?.amount_to_be_paid_net_off_tds);
          temp.push({
            order_id: item?.order_id,
            order_flag: item?.grid_status === "Paid" ? true : false,
          });
        });
        setStatusArray(temp);
        setAllOrdersTotal(sum);
        setGridOrders(res?.orders);
        setStatus(res?.grid_status);
        if (res?.grid_status === "Paid") {
          setSelectedOrdersTotal(sum);
        }
        setLoading(false);
      });
  };

  const fetchGridAtPage = async (targetPage) => {
    if (targetPage < 1 || (totalGrids > 0 && targetPage > totalGrids)) return;

    setLoading(true);
    const token = localStorage.getItem("token");
    const selectedTab = tabNames[activeTab] || "Pending";

    try {
      const response = await fetch(
        `/workflow/api/orders/grids?org_id=2&is_wd=true&tab_name=${selectedTab}&page=${targetPage}&limit=1${
          searchQuery ? `&id=${searchQuery}` : ""
        }`,
        { headers: { Authorization: `Bearer ${token}` } }
      );
      const data = await response.json();

      if (data?.status && data?.grids?.length > 0) {
        const newGridId = data.grids[0].id;
        resetGridViewState();
        setCurrentGridId(newGridId);
        setGridPage(targetPage);
        history(location.pathname, {
          replace: true,
          state: {
            ...location.state,
            id: newGridId,
            gridPage: targetPage,
            activeTab,
            totalGrids,
            searchQuery,
          },
        });
      } else {
        toast.error("No grid found");
        setLoading(false);
      }
    } catch (error) {
      toast.error("Failed to fetch grid");
      setLoading(false);
    }
  };

  const handlePreviousGrid = () => {
    if (gridPage > 1) fetchGridAtPage(gridPage - 1);
  };

  const handleNextGrid = () => {
    if (totalGrids === 0 || gridPage < totalGrids) fetchGridAtPage(gridPage + 1);
  };

  const open = Boolean(anchorEl);
  const dispatch = useDispatch();
  const handleClick = (event) => {
    setAnchorEl(event.currentTarget);
  };
  const handleClose = () => {
    setAnchorEl(null);
  };
  const logout = () => {
    AuthService.logout();
    dispatch(removeToken);
    history("/login");
  };
  const id = open ? "simple-popover" : undefined;

  useEffect(() => {
    getTableData();
  }, [toGetUpdatedList, currentGridId]);

  console.log(statusArray);
  const submitMarkAsPaid = () => {
    let temp = statusArray;
    console.log(statusArray);
    let tempArray = [];
    temp.map((item, index) => {
      if (item?.order_flag === true) {
        tempArray.push(item?.order_id);
      }
    });
    let finalTemp = [];
    gridOrders.map((item, index) => {
      if (tempArray.includes(item?.order_id)) {
        if (item?.grid_status !== "Paid") {
          finalTemp.push({
            id: item?.order_id,
            amount_paid: item?.total_cp,
            status: "Paid",
          });
        } else {
          finalTemp.push({
            id: item?.order_id,
            amount_paid: item?.total_cp,
            status: item?.grid_status,
          });
        }
      }
    });

    if (status === "Paid") {
      return toast.error("This grid has already added as Marked as Paid");
    }
    setLoading(true);
    const token = localStorage.getItem("token");
    const config = {
      headers: { Authorization: `Bearer ${token}` },
    };
    const payload = {
      orders: finalTemp,
      grid_status:
        gridOrders?.length === tempArray?.length ? "Paid" : "Pending",
      actioner: userDetails?.user_name
        ? userDetails?.user_name
        : userDetails?.user_category,
    };
    axios
      .put(`/workflow/api/grid/${gridId}/paid`, payload, config)
      .then((data) => {
        if (data?.data?.status === false) {
          setLoading(false);
          toast.error(data?.data?.message);
        } else {
          setTogetUpdatedList(true);
          toast.success(data?.data?.message);
          setTimeout(function () {
            history("/ayekart-fintech/grids");
          }, 1000);
        }
      });
  };

  const cancelGrid = () => {
    if (window.confirm("Do you really want to cancel this Grid?")) {
      let temp = gridOrders?.map((itemGrid, indexGrid) => itemGrid?.order_id);
      setLoading(true);
      const token = localStorage.getItem("token");
      const config = {
        headers: { Authorization: `Bearer ${token}` },
      };
      const payload = {
        orders: temp,
        grid_status: "Rejected",
        actioner: userDetails?.user_name
          ? userDetails?.user_name
          : userDetails?.user_category,
      };
      axios
        .put(`/workflow/api/grid/${gridId}/paid`, payload, config)
        .then((data) => {
          if (data?.data?.status === false) {
            setLoading(false);
            toast.error(data?.data?.message);
          } else {
            toast.success("Grid has been cancelled");
            setTimeout(function () {
              history("/ayekart-fintech/grids");
            }, 1000);
          }
        });
    }
  };

  const getCSVForSBI = () => {
    // setLoading(true);
    // fetch(`/workflow/api/${location?.state?.id}/finance?bank=sbi`)
    //   .then((res) => res.json())
    //   .then((res) => {
    //     setGridOrders(res?.orders);
    //     setLoading(false);
    //   });
    return toast.error("No records found to download...");
  };

  const getCSVForIcici = () => {
    setLoading(true);
    fetch(`/workflow/api/${gridId}/finance?bank=icici`)
      .then((res) => res.json())
      .then((res) => {
        setGridOrders(res?.orders);
        setLoading(false);
      });
  };

  const getCSVForAxis = () => {
    setLoading(true);
    fetch(`/workflow/api/${gridId}/finance?bank=sbi`)
      .then((res) => res.json())
      .then((res) => {
        setGridOrders(res?.orders);
        setLoading(false);
      });
  };

  useEffect(() => {}, [selectAll]);

  const changeStatusInStatusArray = (e, ind) => {
    let temp = statusArray;
    temp.map((item, tempIndex) => {
      if (tempIndex === ind) {
        if (e.target.checked) {
          temp[tempIndex].order_flag = e.target.checked;
        } else {
          temp[tempIndex].order_flag = e.target.checked;
        }
      }
    });
    let tempTotal = 0;
    temp?.map((item, index) => {
      if (item?.order_flag === true) {
        tempTotal =
          tempTotal + Number(gridOrders[index].amount_to_be_paid_net_off_tds);
      }
    });
    setSelectedOrdersTotal(tempTotal);
    setStatusArray(temp);
    setDummy(e.target.checked);
  };

  const selectAllFun = (e) => {
    setSelectAll(e.target.checked);
    if (e.target.checked) {
      setSelectedOrdersTotal(allOrdersTotal);
      let temp = statusArray;
      temp.map((item, index) => {
        if (gridOrders[index]?.grid_status === "Paid") {
          temp[index].order_flag = false;
        } else {
          temp[index].order_flag = true;
        }
      });
      setStatusArray(temp);
    } else {
      let temp = statusArray;
      temp.map((item, index) => {
        temp[index].order_flag = false;
      });
      setStatusArray(temp);
      setSelectedOrdersTotal(0);
    }
  };

  //-----------------------------------------------------
  return (
    <div className=" ">
      <div className="container-fluid">
        <Loader loading={loading} />
        <div className="p-1 mt-2">
          <div className="container-fluid">
            <span
              onClick={() => history('/ayekart-retail/advance-wholesale-distribution/grids',{ state: location?.state })}
              className="cursor-pointer text-primary"
            >
              <i className="fa fa-arrow-left mr-1" aria-hidden="true"></i>
              Back to Grids
            </span>
          </div>
          <div className="container-fluid mt-4 p-0">
            <div className="row mx-0 bg-white">
              <div className="col col-sm-12 col-md-12 col-lg-2 border pt-3 rounded-md">
                <div className="row">
                  <span className="">
                    <span className="fs-5 fw-semibold">Total CP(₹)</span>
                  </span>
                  <h5>₹ {Number(allOrdersTotal).toFixed(2)} </h5>
                </div>
                 
              </div>
              <div className="col col-sm-12 col-md-12 col-lg-10 p-2 border">
                <div className="container-fluid text-center mt-2">
                  <div className="row gy-3 d-flex mx-0 justify-content-end mt-2 pb-2">
                    <div className="col d-flex align-items-center gap-2 flex-wrap">
                      <button
                        type="button"
                        className="btn btn-outline-primary btn-sm"
                        onClick={handlePreviousGrid}
                        disabled={gridPage <= 1 || loading}
                      >
                        Previous Grid
                      </button>
                      <span className="font-semibold fs-5 mb-0">
                        Grid No. {gridId} Orders
                      </span>
                      <button
                        type="button"
                        className="btn btn-outline-primary btn-sm"
                        onClick={handleNextGrid}
                        disabled={
                          loading || (totalGrids > 0 && gridPage >= totalGrids)
                        }
                      >
                        Next Grid
                      </button>
                      {totalGrids > 0 && (
                        <span className="text-muted small">
                          ({gridPage} of {totalGrids})
                        </span>
                      )}
                    </div>
                    <div className="col col-sm-12 col-md-6 col-lg-2 pl-0"></div>
                  </div>
                  <div className="row finance-grid-table-head">
                    <div className="col col-sm-1 col-md-1 col-lg-1 pt-2 finance-grid-bg-adb2da d-flex">
                      <span className="w-25">
                        {/* <input
                      type="checkbox"
                      className="form-check w-100"
                      checked={selectAll}
                      onChange={(e) => {
                        setDummy(e.target.checked);
                        selectAllFun(e);
                      }}
                      disabled={status === "Paid" ? true : false}
                    /> */}
                      </span>
                      <h5>Order ID</h5>
                    </div>
                    <div className="col col-sm-3 col-md-3 col-lg-3 pt-2 finance-grid-bg-adb2da">
                      <h5>Supplier Shop Name</h5>
                    </div>
                    <div className="col col-sm-2 col-md-2 col-lg-2 pt-2 finance-grid-bg-adb2da">
                      <h5>Total CP(₹)</h5>
                    </div>
                    <div className="col col-sm-2 col-md-2 col-lg-2 pt-2 finance-grid-bg-adb2da">
                      <h5>Total payable(₹)</h5>
                    </div>
                    <div className="col col-sm-2 col-md-2 col-lg-2 pt-2 finance-grid-bg-adb2da">
                      <h5>TDS(₹)</h5>
                    </div>
                    <div className="col col-sm-2 col-md-2 col-lg-2 pt-2 finance-grid-bg-adb2da">
                      <h5> Amount To Be Paid Net Off TDS(₹)</h5>
                    </div>
                  </div>
                  <div className="row mt-2 finance-grid-tbody">
                    <div className="container-fluid ">
                      {gridOrders?.length > 0 ? (
                        gridOrders?.map((item, index) => (
                          <React.Fragment key={index}>
                            <div className="row mb-2">
                              <div className="col col-sm-1 col-md-1 col-lg-1 pt-3 pb-2 finance-grid-bg-bec3ee d-flex">
                                <span className="w-25"></span>
                                <h6 className=" mt-1">{item?.order_id}</h6>
                              </div>
                              <div className="col col-sm-3 col-md-3 col-lg-3 pt-3 pb-2 finance-grid-bg-bec3ee">
                                <h6 className=" mt-1">
                                  {item?.supplier_shop_name}
                                </h6>
                              </div>
                              <div className="col col-sm-2 col-md-2 col-lg-2 pt-3 pb-2 finance-grid-bg-bec3ee">
                                <input
                                  className="form-control"
                                  type="text"
                                  readOnly
                                  name=""
                                  value={item?.total_payable_net_off_tds}
                                />
                              </div>
                              <div className="col col-sm-2 col-md-2 col-lg-2 pt-3 pb-2 finance-grid-bg-bec3ee">
                                <input
                                  readOnly
                                  className="form-control"
                                  type="text"
                                  name=""
                                  value={item?.total_payable}
                                  placeholder="TDS"
                                />
                              </div>
                              <div className="col col-sm-2 col-md-2 col-lg-2 pt-3 pb-2 finance-grid-bg-bec3ee">
                                <input
                                  readOnly
                                  className="form-control"
                                  type="text"
                                  name=""
                                  value={item?.tds}
                                  placeholder="Total Amount"
                                />
                              </div>
                              <div className="col   col-sm-2 col-md-2 col-lg-2 pt-3 finance-grid-bg-bec3ee">
                                <h6>{item?.amount_to_be_paid_net_off_tds}</h6>
                              </div>
                            </div>
                          </React.Fragment>
                        ))
                      ) : (
                        <>
                          <div className="row mt-2 finance-grid-tbody-no-data">
                            <p>No Data Added</p>
                          </div>
                        </>
                      )}
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>

        <Toaster />
      </div>
    </div>
  );
}

export default OperationsAyekartRetailWDGridView;
